import * as React from 'react'
import { motion } from 'framer-motion'
import { cn } from '../../utils/cn'

/**
 * JPG Academy Card
 *
 * A contained content surface with warm shadows and subtle borders.
 * Motion is built in and respects prefers-reduced-motion.
 */

export interface CardProps {
	className?: string
	children?: React.ReactNode
	warm?: boolean
	noPadding?: boolean
}

export function Card({ className, warm = false, children }: CardProps) {
	return (
		<motion.div
			className={cn(
				'rounded-lg border shadow-sm transition-shadow duration-normal ease-default hover:shadow-md',
				warm ? 'bg-cream border-cream-dark text-navy-700' : 'bg-card border-border text-card-foreground',
				className,
			)}
		>
			{children}
		</motion.div>
	)
}

export function CardHeader({ className, children }: { className?: string; children?: React.ReactNode }) {
	return <div className={cn('flex flex-col space-y-1.5 p-6', className)}>{children}</div>
}
export function CardTitle({ className, children }: { className?: string; children?: React.ReactNode }) {
	return <h3 className={cn('font-display text-h3 uppercase tracking-trajan font-bold', className)}>{children}</h3>
}
export function CardDescription({ className, children }: { className?: string; children?: React.ReactNode }) {
	return <p className={cn('text-body-sm text-muted-foreground font-body', className)}>{children}</p>
}
export function CardContent({ className, children }: { className?: string; children?: React.ReactNode }) {
	return <div className={cn('p-6 pt-0', className)}>{children}</div>
}
export function CardFooter({ className, children }: { className?: string; children?: React.ReactNode }) {
	return <div className={cn('flex items-center p-6 pt-0', className)}>{children}</div>
}
